
export const baseUrl = 'https://atci.lkm.accenture.com/lttmicrosite-apis';
